import { ACCESS_TOKEN } from '../constants/cookies'
import Cookies from 'js-cookie'

export default function logout() {
  Cookies.remove(ACCESS_TOKEN)
}
